!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.networklayer = t() : e.networklayer = t();
}(window, function () {
  return function (e) {
    var t = {};

    function r(o) {
      if (t[o]) return t[o].exports;
      var n = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, o) {
      r.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, r.r = function (e) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 0);
  }([function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = {
      POST: "POST",
      GET: "GET",
      DELETE: "DELETE",
      PATCH: "PATCH",
      PUT: "PUT"
    };

    function n(e) {
      var t = this;
      if (!e) throw new Error("Missing routes");
      if (this.routes = e, 0 === Object.keys(e).length) throw new Error("APIConfig needs at least one valid route definition");
      return this.request = function (e) {
        var r = t.routes[e];
        if (!r) throw new Error("Route " + e + " is not defined: check Routes initialization");
        return new i(r);
      }, Object.keys(e).forEach(function (e) {
        var r = t.routes[e];
        t[e] = new i(r).with;
      }), this;
    }

    function i(e) {
      var t = this;
      return this.route = e, this.with = function (e) {
        var r = t.route.method || o.GET,
            n = {
          resolved: !0
        },
            i = t.route.url(e),
            u = {
          Accept: t.route.acceptHeaders || "application/json",
          "Content-Type": t.route.contentType || "application/json;charset=utf-8"
        };

        if (t.route.authenticate) {
          if (!e.token) throw new Error("Did not pass token to authenticate at url " + i);
          u.Authorization = "Bearer: " + e.token;
        }

        var s = {
          method: r,
          headers: u,
          redirect: "manual"
        };

        if (r !== o.GET) {
          var c = e && e.body || e;
          s.body = JSON.stringify(c);
        }

        var a = new Request(i, s),
            f = -1;
        return fetch(a).then(function (e) {
          return f = e.status, "opaqueredirect" === e.type ? n : r === o.DELETE && f < 400 ? n : "application/json" === u.Accept ? e.json() : e;
        }).then(function (e) {
          return e.hasOwnProperty("error") ? Promise.reject(e) : Promise.resolve(e || n);
        }).catch(function (e) {
          return f > -1 && f < 400 ? Promise.resolve(n) : Promise.reject(e);
        });
      }, this;
    }

    t.default = {
      APIConfig: n,
      METHODS: o
    }, n.prototype.METHODS = o;
  }]).default;
});